import { useMsal } from '@azure/msal-react';
import { useCallback, useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { AuthRedirectDetails, AuthRedirectReason, trackAuthRedirect } from '@/utils/authTelemetry';

export default function useAuth() {
  const { b2cId } = useContext(TokenContext);
  const { instance } = useMsal();

  const logoutCurrentUser = useCallback(
    async (reason: AuthRedirectReason, details?: AuthRedirectDetails): Promise<void> => {
      if (b2cId == null) return;
      // TODO(bug): b2cId is AuthenticationResult.uniqueId (the oid / localAccountId), but
      // getAccountByHomeId expects homeAccountId, which for B2C is `<oid>-<policy>.<tenantId>` — so
      // this always resolves to null and MSAL logs out *all* cached accounts without a logout hint.
      // Low impact today; expected: getAccountByLocalId(b2cId) or instance.getActiveAccount().
      // Same pattern in AuthWrapper.onIdle and useAuthEvents (forgot-password branch).
      const logoutRequest = {
        account: instance.getAccountByHomeId(b2cId),
      };
      trackAuthRedirect(reason, { b2cId, ...details });
      await instance.logoutRedirect(logoutRequest);
    },
    [instance, b2cId]
  );

  return { logoutCurrentUser };
}
